import { createSelector } from "reselect"
import { get } from "lodash"
import { getQueryGroupBy } from "helpers/rollups"
import { getContentSets, getSelectedViewIsContentSet, getSelectedContentSetCategories, getSelectedContentSetDataType } from "selectors/contentSets"
import { computeAssetViewMenuItems, computeSubViewOptions, computeSelectedMetricType, computeContentSetFactorsFromCategories, computeSelectedSubView, computeMetricTypeOptions, computeSort, computeColumnOrderOptions } from "helpers/assets"
import { getIsOpPro } from "modules/account-root/selectors"
import { getSelectedView } from "selectors/assets"
import { getBaseMetricTypeOptions } from "selectors/assets/metricTypes"
import { getDefaultMetricUnits } from "modules/default-metric-units/selectors"
import { getModelCategories } from "selectors/modelMetadata"

export const getSelectedPage = state => get(state, "modules.intradayAssetTable.page")
export const getSelectedGroup = state => get(state, "modules.intradayAssetTable.selectedGroup")
export const getRawSelectedMetricType = state => get(state, "modules.intradayAssetTable.selectedMetricType")
export const getRawSelectedSubView = state => get(state, "modules.intradayAssetTable.selectedSubView")
export const getGroupingOptions = (_, props) => getQueryGroupBy(get(props, "currentGrouping"))
export const getRawSort = state => get(state, "modules.intradayAssetTable.sort")
export const getLastRefresh = (_, props) => get(props, "lastRefresh")
export const getModelId = (_, props) => get(props, "modelId")
export const getDisableColumnClick = (_, props) => get(props, "disableColumnClick", false)
const getAssetType = (_, props) => props.assetType

export const getMenuItems = createSelector(
  [getIsOpPro, getContentSets],
  computeAssetViewMenuItems,
)

export const getIdSort = createSelector(
  [getRawSort],
  computeSort,
)

export const getMetricTypeOptions = createSelector(
  [getBaseMetricTypeOptions, getSelectedView, getSelectedViewIsContentSet, getAssetType, getSelectedContentSetDataType, getDefaultMetricUnits],
  computeMetricTypeOptions,
)

export const getColumnOrderOptions = createSelector(
  [getSelectedView],
  computeColumnOrderOptions,
)

export const getSelectedMetricType = createSelector(
  [getRawSelectedMetricType, getMetricTypeOptions],
  computeSelectedMetricType,
)

export const getSubViewOptions = createSelector(
  [getSelectedView, getSelectedContentSetCategories, getModelCategories, getSelectedViewIsContentSet],
  computeSubViewOptions,
)

export const getSelectedSubView = createSelector(
  [getRawSelectedSubView, getSubViewOptions],
  computeSelectedSubView,
)

export const getContentSetCategoryFactors = createSelector(
  [getSelectedSubView, getSelectedContentSetCategories],
  computeContentSetFactorsFromCategories,
)
